import { useFormStore } from '@/stores/form'
import router from '@/router'

const checkBackWizard = () => {
  const formStore = useFormStore()
  const { departmentCode, serviceYear, serviceCode, sequenceNumber } = formStore.form.values || {}
  return ![departmentCode, serviceYear, serviceCode, sequenceNumber].some(
    (x) => x === null || x === undefined
  )
}

export default async function () {
  const formStore = useFormStore()
  formStore.extraMap = {
    ...formStore.extraMap,
    showForm: false,
    backWizard: false,
    userExist: false,
    disabledDateOfBirth: true,
    fileTypes: [2, 3, 7] // must service code not equal these types.
  }
  if (formStore.draft.requestNumber && checkBackWizard()) {
    formStore.extraMap.showForm = true
    formStore.extraMap.backWizard = true
  }
}
